import { CreateElement, Point, Rect, Size } from "../.././MyHelpers";
import { ImageResource } from "../../ResourceManager/ImageResource";
import { ZIndex } from "../../ZIndex";
import { PlayWindow } from "../../api";
import { MyCanvas } from "../MyCanvas";
import { ReelSetMapper } from "../SpinAnimation/ReelSetMapper";
import { SpinAnimation } from "../SpinAnimation/SpinAnimation";
import { ISpinnableReels } from "../SpinAnimation/SpinnableReels";

// export namespace S2
// {
export interface S2_SpinnableReelsConfig
{
	playWindow: PlayWindow;
	reelConfig: S2_IReelConfig[];
}

export interface S2_SpinnableReelDisplayGeometry
{

/*

		+-----+
		|  4  |
		|  3  | invisible symbols above
		+-----+
		|  2  |
		|  1  |  visible symbols above
		|  0  |  <- stop position
		+-----+ 
		|  1  | invisible symbols below (could also have visible symbols below)
		+-----+


		image shows 6 symbols, 5 above and 1 below the stop position
*/

	// number of symbols to show above stop position (visible + hidden)
	symbolsAbove: number;

	// number of symbols to show below stop position (visible + hidden)
	symbolsBelow: number;

	// total of symbols to show (visible + hidden)
	symbolsTotal: number;
}

export interface S2_ISpinnableReelsParams
{
	windowRect: Rect;

	topBorderWidth?: number;
	bottomBorderWidth?: number;
	leftBorderWidth?: number;
	rightBorderWidth?: number;

	backgroundImage?: ImageResource;
	pixiSpritesByName?: Map<string, any[]>;
}

export interface S2_IReelConfig
{
	// what is the name of the reel?
	Name: string;

	// what is the original index from backend?
	Index: number;

	// what is the starting row on the grind?
	Row: number;

	// what is the starting column on the grid?
	Col: number;
	
	// how many columns does the reel span?
	ColSpan: number;

	// how many rows does the reel span?
	RowSpan: number;

	// How many symbols to show on this reel?
	Height: number;

	// where does reel start at first?
	StartPosition?: number;

	ExtraSymbolsAbove?: number;

	// indexes of symbols symbols on the reel
	Symbols: number[];
}

export interface S2_SymbolTranslation
{
	reelIndex: number;
	rowIndex: number;
	reel: S2_ISpinnableReel;
}

export interface S2_ISpinnableReel
{
	/*
	protected symbolSize: Size;

	public constructor(symbolSize: Size)
	{
		this.symbolSize = symbolSize;
	}

	public GetSymbolSize(): Size
	{
		return this.symbolSize;
	}
	*/

	Config: S2_IReelConfig;

	// rect of reel in pixels
	ReelRect: Rect;

	// the size of symbol in pixels
	SymbolSizeInPixels: Size;

	// reel window element with overhang
	ReelWindowElement: HTMLElement;

	// hides borders while spinning
	SpinMaskElement: HTMLElement;

	// reel window without overhang
	NormalizedWindowElement: HTMLElement;
	
	BackgroundRect_symbols: Rect;
	BackgroundRect_pixels: Rect;
	WindowBackgroundElement: HTMLElement;

	// this element gets translated, contains all canvases on reel
	ReelElement: HTMLElement;

	// parts of reels
	TopHiddenSymbols: HTMLElement;
	MiddleVisibleSymbols: HTMLElement;
	BottomHiddenSymbols: HTMLElement;

	Canvases: MyCanvas[];

	//InflatedCanvasRect: PixelRect[];
	//OriginalCanvasRect: PixelRect[];

	// normalized to the canvas
	NormalizedOriginalCanvasRect: Rect;

	OriginalSymbolSize: Size;
	InflatedSymbolSize: Size;

	originalSymbolScaleX: number;
	originalSymbolScaleY: number;
	originalSymbolScale: number;

	inflatedSymbolScaleX: number;
	inflatedSymbolScaleY: number;
	inflatedSymbolScale: number;


	AbsoluteSymbolRects: Map<number, Rect>;

	ReelDisplayGeometry: S2_SpinnableReelDisplayGeometry;
}

export class S2_SpinnableReels2 implements ISpinnableReels {

	//protected numReels: number = 0;
	//protected numRows: number = 0;

	// window size in number of symbols
	//protected windowSymbolSize: Size = new Size(5, 4);

	// total window size in number of ymbols, including hidden symbols
	protected extendedWindowSymbolSize: Size = new Size();/**/


	// additional rows to add on tom of animation
	protected readonly numAdditionalRowsTop: number = 2;

	// TODO does not work for > 0, shifts symbols below in ReelSetMapper?
	protected readonly numAdditionalRowsBottom: number = 0;

	// size of whole window, in pixels
	//protected windowRect: PixelRect = null;

	// size of one symbol. in pixels
	protected symbolSize: Size = new Size();

	protected centerOfReel: Point[] = [];

	//protected symbolWidth: number = 0;
	//protected symbolHeight: number = 0;

	protected slotWindowElement: HTMLElement = null;
	protected reelWindowElemsList: HTMLElement [] = [];
	public get ReelWindowElements(): HTMLElement[] 
	{
		return this.reelWindowElemsList;
	}

	protected reelElemsList: HTMLElement[] = [];
	public get ReelElements(): HTMLElement[]
	{
		return this.reelElemsList;
	}

	protected spinAnimation: SpinAnimation = null;
	protected reelSetMapper: ReelSetMapper = null;

	protected logGroup: string = "S2.SpinnableReels";

	// canvas element for each symbol
	// first index = reel index
	// second index = row index
	public canvas: MyCanvas[][] = [];

	/*

		+---+---+---+---+---+
		|   |           |   |
		+---+           +---+
		|   |           |   |
		+---+           +---+
		|   |           |   |
		+---+-----------+---+

	*/

	protected config: S2_SpinnableReelsConfig = null;

	protected params: S2_ISpinnableReelsParams = null;

	protected animationColumns: number[];
	protected symbolElements: MyCanvas[];
	protected symbolsInColumn: MyCanvas[][];

	protected reels: S2_ISpinnableReel[];
	protected reelsInAnimationColumn: S2_ISpinnableReel[][];

	//protected verticalBorderWidth: number = 2;
	//protected horizontalBorderWidth: number = 2;

	protected maxSymbolHeightInPixels: number = 0;
	protected maxReelHeightInSymbols: number = 0;


	public constructor(config: S2_SpinnableReelsConfig, params: S2_ISpinnableReelsParams = null) {
		this.config = config;

		let defaultParams: S2_ISpinnableReelsParams = {
			windowRect: null,
			backgroundImage: null,
			bottomBorderWidth: 0,
			leftBorderWidth: 0,
			rightBorderWidth: 0,
			topBorderWidth: 0
		};

		this.params = {...defaultParams, ...params};

		// extended size, for hidden symbols on top
		this.extendedWindowSymbolSize = new Size(this.config.playWindow.Width, this.config.playWindow.Height + this.numAdditionalRowsTop + this.numAdditionalRowsBottom);
		//this.windowRect = windowRect;

		// find symbol size, based on window size and number of reels/rows
		//let windowInnerWidth = this.params.windowRect.width - this.params.leftBorderWidth - this.params.rightBorderWidth;
		//let windowInnerHeight = this.params.windowRect.height - this.params.topBorderWidth - this.params.bottomBorderWidth;

		// this is now inner window size, reduced by border
		//let windowInnerRect = new PixelRect(this.params.leftBorderWidth, this.params.topBorderWidth, windowInnerWidth, windowInnerHeight);

		//// Log.Debug(this.logGroup, "Inner window rect (borders compensated): " + windowInnerRect.toString());

		let symbolWidth = Math.round(this.params.windowRect.width / this.config.playWindow.Width);
		// if (symbolWidth - Math.round(symbolWidth) != 0) {
		// 	Log.Error(this.logGroup, "Window width is not equally divisible by number of symbols: window width = " + this.params.windowRect.width + ", reels = " + this.config.windowSymbolsSize.width);
		// }

		let symbolHeight = Math.round(this.params.windowRect.height / this.config.playWindow.Height);
		// if (symbolHeight - Math.round(symbolHeight) != 0) {
		// 	Log.Error(this.logGroup, "Window height is not equally divisible by number of symbols: window height = " + this.params.windowRect.height + ", symbols = " + this.config.windowSymbolsSize.height);
		// }

		this.symbolSize = new Size(symbolWidth, symbolHeight);

		//console.log("Symbol size", this.symbolSize);
		this.animationColumns = this.config.reelConfig.map(r => r.Col).filter((value, index, result) => result.indexOf(value) == index).sort((a, b) => a - b);
		
		this.ConstructReels();
	}

	protected PrepareSymbolRect(originalSymbolRect: Rect): Rect
	{

		// return as it is
		return originalSymbolRect;

		// turn into perfect rectangle
		let minSide = Math.min(originalSymbolRect.width, originalSymbolRect.height);

		let topOffset = (originalSymbolRect.height - minSide) / 2;
		let leftOffset = (originalSymbolRect.width - minSide) / 2;

		return new Rect(
			originalSymbolRect.x + leftOffset,
			originalSymbolRect.y + topOffset,
			minSide,
			minSide
		);
	}

	protected InflateSymbolRect(originalSymbolRect: Rect, preparedSymbolRect: Rect): Rect
	{
		// inflate by 5%
		//return preparedSymbolRect.Inflate(new Size(preparedSymbolRect.width * 0.05, preparedSymbolRect.height * 0.05));
		return preparedSymbolRect;
	}

	protected InflateWindowRect(originalWindowRect: Rect, preparedWindowRect: Rect): Rect
	{
		//return originalWindowRect;
		return this.InflateSymbolRect(originalWindowRect, preparedWindowRect);
	}

	protected InflateReelRect(originalReelRect: Rect, preparedReelRect: Rect): Rect
	{
		return originalReelRect;
	}

	// TODO add reel backgrounds
	protected ConstructReels() 
	{

		// prepare slot window
		let inflatedWindowRect = this.InflateWindowRect(this.params.windowRect, this.params.windowRect);
		let normalizedWindowRect: Rect = new Rect(
			this.params.windowRect.x - inflatedWindowRect.x,
			this.params.windowRect.y - inflatedWindowRect.y,
			this.params.windowRect.width,
			this.params.windowRect.height
		);

		this.slotWindowElement = CreateElement("div", {classes: ["SpinnableReels2-SlotWindow"], style: {
			position: "absolute",
			left: inflatedWindowRect.x + "px",
			top: inflatedWindowRect.y + "px",
			width: inflatedWindowRect.width + "px",
			height: inflatedWindowRect.height + "px",
			//overflow: "hidden",
		}});

		let innerSlotWindowElement = CreateElement("div", {classes: ["SpinnableReels2-InnerSlotWindow"], 
			parentToAppend: this.slotWindowElement,
			style: {
				position: "absolute",
				left: normalizedWindowRect.x + "px",
				top: normalizedWindowRect.y + "px",
				width: normalizedWindowRect.width + "px",
				height: normalizedWindowRect.height + "px",
			}
		});

		// let numColors: number = this.config.reelConfig.map(r => r.Height + this.numAdditionalRowsTop + this.numAdditionalRowsBottom).reduce((sum, height) => sum += height, 0);
		// let colors: Color[] = MakeColorGradient(2.4, 2.4, 2.4, 0, 2, 4, 128, 127, numColors, 0.2);
		// console.log("Colors", colors);

		this.symbolElements = [];
		this.symbolsInColumn = new Array(this.animationColumns.length);
		this.reelsInAnimationColumn = new Array(this.animationColumns.length);



		this.config.reelConfig.forEach((reelConfig, index) => {

			let animationColumnIndex = this.animationColumns.indexOf(reelConfig.Col);


			let reelRect_symbols = new Rect(
				reelConfig.Col,
				reelConfig.Row,
				reelConfig.ColSpan,
				reelConfig.RowSpan
			);

			let reelRect_pixels: Rect = new Rect(
				reelRect_symbols.x * this.symbolSize.Width,
				reelRect_symbols.y * this.symbolSize.Height,

				reelRect_symbols.width * this.symbolSize.Width,
				reelRect_symbols.height * this.symbolSize.Height
			);

			// TODO take into account additional symbol above
			let rowsPerSymbol = reelConfig.RowSpan / reelConfig.Height;
			let row = reelConfig.Row - (rowsPerSymbol * (reelConfig.ExtraSymbolsAbove || 0));
			let rowSpan = reelConfig.RowSpan + (rowsPerSymbol * (reelConfig.ExtraSymbolsAbove || 0));
			let heightInSymbols = reelConfig.Height + (reelConfig.ExtraSymbolsAbove || 0);

			let reelRectExtraSymbols_symbols = new Rect(
				reelConfig.Col,
				row,
				reelConfig.ColSpan,
				rowSpan
			);

			let reelRectExtraSymbols_pixels: Rect = new Rect(
				reelRectExtraSymbols_symbols.x * this.symbolSize.Width,
				reelRectExtraSymbols_symbols.y * this.symbolSize.Height,

				reelRectExtraSymbols_symbols.width * this.symbolSize.Width,
				reelRectExtraSymbols_symbols.height * this.symbolSize.Height
			);

			//console.log("Reel " + reelConfig.Name, reelRectExtraSymbols_pixels);


			let inflatedReelRect = this.InflateReelRect(reelRectExtraSymbols_pixels, reelRectExtraSymbols_pixels);
			let normalizedReelRect = new Rect(
				reelRectExtraSymbols_pixels.x - inflatedReelRect.x,
				reelRectExtraSymbols_pixels.y - inflatedReelRect.y,
				reelRectExtraSymbols_pixels.width,
				reelRectExtraSymbols_pixels.height
			);

			let symbolSize = new Size(
				normalizedReelRect.width,
				normalizedReelRect.height / heightInSymbols
			);

			let backgroundRect_symbols = reelRect_symbols;
			let backgroundRect_pixels: Rect = reelRect_pixels;

			// TODO MAKE SETTINGS FOR THIS
			// include extra symbols
			backgroundRect_symbols = reelRectExtraSymbols_symbols;
			backgroundRect_pixels = reelRectExtraSymbols_pixels;

			let backgroundElement = CreateElement("div", {
				classes: ["reelBackground-" + reelConfig.Index, "reelBackground-" + reelConfig.Name],
				parentToAppend: innerSlotWindowElement,
				style: {
					position: "absolute",
					//overflow: "hidden", // don't show 
					left: backgroundRect_pixels.x + "px",
					top: backgroundRect_pixels.y + "px",
					width: backgroundRect_pixels.width + "px",
					height: backgroundRect_pixels.height + "px",
					zIndex: ZIndex.ReelContainerBackground.toString()
				}
			});

			let reelWindowElement = CreateElement("div", {
				classes: ["reelWindow-" + reelConfig.Index, "reelWindow-" + reelConfig.Name],
				parentToAppend: innerSlotWindowElement,
				style: {
					position: "absolute",
					overflow: "hidden", // don't show 
					left: inflatedReelRect.x + "px",
					top: inflatedReelRect.y + "px",
					width: inflatedReelRect.width + "px",
					height: inflatedReelRect.height + "px",
					zIndex: ZIndex.ReelContainer.toString()
				}
			});



			let normalizedReelWindowElement = CreateElement("div", {
				classes: ["normalizedReelWindow-" + reelConfig.Index, "normalizedReelWindow-" + reelConfig.Name],
				parentToAppend: reelWindowElement,
				style: {
					position: "absolute",
					//overflow: "hidden", // don't show 
					left: normalizedReelRect.x + "px",
					top: normalizedReelRect.y + "px",
					width: normalizedReelRect.width + "px",
					height: normalizedReelRect.height + "px",
				}
			});

			let spinMaskRect = new Rect(
				this.params.leftBorderWidth,
				this.params.topBorderWidth,
				normalizedReelRect.width - this.params.leftBorderWidth - this.params.rightBorderWidth,
				normalizedReelRect.height - this.params.topBorderWidth - this.params.bottomBorderWidth
			);

			let spinMaskWindow = CreateElement("div", {
				classes: ["spinMaskWindow-" + reelConfig.Index , "spinMaskWindow-" + reelConfig.Name],
				parentToAppend: normalizedReelWindowElement,
				style: {
					position: "absolute",
					left: spinMaskRect.x + "px",
					top: spinMaskRect.y + "px",
					width: spinMaskRect.width + "px",
					height: spinMaskRect.height + "px",
				}
			});

			let reelElement = CreateElement("div", {
				classes: ["reel-" + reelConfig.Index, "reel-" + reelConfig.Name],
				parentToAppend: spinMaskWindow,
				style: {
					position: "absolute",
					left: -spinMaskRect.x + "px",
					top: -spinMaskRect.y + "px",
					width: normalizedReelRect.width + "px",
					height: normalizedReelRect.height + "px",
				},
			});

			let bottomHiddenSymbols = CreateElement("div", {
				classes: ["bottomHiddenSymbols-" + reelConfig.Index, "bottomHiddenSymbols-" + reelConfig.Name],
				parentToAppend: reelElement,
				style: { visibility: "hidden" }
			});

			let middleVisibleSymbols = CreateElement("div", {
				classes: ["middleVisibleSymbols-" + reelConfig.Index, "middleVisibleSymbols-" + reelConfig.Name],
				parentToAppend: reelElement,
			});

			let topHiddenSymbols = CreateElement("div", {
				classes: ["topHiddenSymbols-" + reelConfig.Index, "topHiddenSymbols-" + reelConfig.Name],
				parentToAppend: reelElement,
				style: { visibility: "hidden" }
			});

			let spinnableReel: S2_ISpinnableReel = {
				Config: reelConfig,

				ReelRect: reelRectExtraSymbols_pixels,
				//ReelWindowElement: reelWindowElement,
				BackgroundRect_symbols: backgroundRect_symbols,
				BackgroundRect_pixels: backgroundRect_pixels,
				
				WindowBackgroundElement: backgroundElement,
				ReelWindowElement: reelWindowElement,
				SpinMaskElement: spinMaskWindow,
				NormalizedWindowElement: normalizedReelWindowElement,
				ReelElement: reelElement,

				TopHiddenSymbols: topHiddenSymbols,
				MiddleVisibleSymbols: middleVisibleSymbols,
				BottomHiddenSymbols: bottomHiddenSymbols,

				SymbolSizeInPixels: symbolSize,
				

				AbsoluteSymbolRects: new Map<number, Rect>(),
				ReelDisplayGeometry: {
					symbolsAbove: heightInSymbols + this.numAdditionalRowsTop,
					symbolsBelow: this.numAdditionalRowsBottom,
					symbolsTotal: heightInSymbols + this.numAdditionalRowsTop + this.numAdditionalRowsBottom
				},

				// will be set in loop below
				Canvases: [],
				NormalizedOriginalCanvasRect: null,
				OriginalSymbolSize: null,
				InflatedSymbolSize: null,

				originalSymbolScaleX: 1,
				originalSymbolScaleY: 1,
				originalSymbolScale: 1,

				inflatedSymbolScaleX: 1,
				inflatedSymbolScaleY: 1,
				inflatedSymbolScale: 1,

				// TODO take into account additional symbol showing on top
				// ReelDisplayGeometry: {
				// 	symbolsAbove: reelConfig.Height + (reelConfig.ExtraSymbolsAbove || 0) + this.numAdditionalRowsTop,
				// 	symbolsBelow: this.numAdditionalRowsBottom,
				// 	symbolsTotal: reelConfig.Height + (reelConfig.ExtraSymbolsAbove || 0) + this.numAdditionalRowsTop + this.numAdditionalRowsBottom
				// }
			};

			this.canvas[index] = [];


			if (!this.reels) this.reels = [];
			this.reels.push(spinnableReel);

			if (!this.reelsInAnimationColumn[animationColumnIndex]) this.reelsInAnimationColumn[animationColumnIndex] = [];
			this.reelsInAnimationColumn[animationColumnIndex].push(spinnableReel);






			for (let s = 0; s < spinnableReel.ReelDisplayGeometry.symbolsTotal; s++)
			{
				let reverseRow = spinnableReel.ReelDisplayGeometry.symbolsTotal - 1 -  s;

				let originalSymbolRect: Rect = new Rect(
					0,
					(reverseRow - this.numAdditionalRowsTop) * symbolSize.Height,
					symbolSize.Width,
					symbolSize.Height
				);


				let absoluteSymbolRect: Rect = new Rect(
					this.params.windowRect.x + reelRectExtraSymbols_pixels.x + originalSymbolRect.x,
					this.params.windowRect.y + reelRectExtraSymbols_pixels.y + originalSymbolRect.y,
					originalSymbolRect.width,
					originalSymbolRect.height
				);

				spinnableReel.AbsoluteSymbolRects.set(reverseRow - this.numAdditionalRowsTop, absoluteSymbolRect);

				let preparedSymbolRect = this.PrepareSymbolRect(originalSymbolRect);
				let inflatedSymbolRect = this.InflateSymbolRect(originalSymbolRect, preparedSymbolRect);

				if (s == 0)
				{
					spinnableReel.NormalizedOriginalCanvasRect = new Rect(
						preparedSymbolRect.x - inflatedSymbolRect.x,
						preparedSymbolRect.y - inflatedSymbolRect.y,
						preparedSymbolRect.width,
						preparedSymbolRect.height
					);

					spinnableReel.OriginalSymbolSize = preparedSymbolRect.Size();
					spinnableReel.InflatedSymbolSize = inflatedSymbolRect.Size();

					spinnableReel.originalSymbolScaleX = spinnableReel.OriginalSymbolSize.Width / spinnableReel.InflatedSymbolSize.Width;
					spinnableReel.originalSymbolScaleY = spinnableReel.OriginalSymbolSize.Height / spinnableReel.InflatedSymbolSize.Height;
					spinnableReel.originalSymbolScale = Math.min(spinnableReel.originalSymbolScaleX, spinnableReel.originalSymbolScaleY);

					spinnableReel.inflatedSymbolScaleX = 1;
					spinnableReel.inflatedSymbolScaleY = 1;
					spinnableReel.inflatedSymbolScale  = 1;

					// Log.Debug(this.logGroup, `Constructing reel ${reelConfig.Index} symbol ${s} rect: ${spinnableReel.NormalizedOriginalCanvasRect.toString()}`);
				}

				// take border of reel into account
				//symbolRect = symbolRect.Resize();

				//let color = colors[this.symbolElements.length].toRgba();

				// let symbolElement = CreateElement("div", {
				// 	classes: ["symbol-" + s],
				// 	parentToAppend: reelElement,
				// 	style: {
				// 		position: "absolute",
				// 		left: inflatedSymbolRect.x + "px",
				// 		top: inflatedSymbolRect.y + "px",
				// 		width: inflatedSymbolRect.width + "px",
				// 		height: inflatedSymbolRect.height + "px",

				// 		//border: "1px solid blue",
				// 		boxSizing: "border-box",
				// 		backgroundColor: color
				// 	},
				// });

				// CreateElement("div", {
				// 	classes: ["normalized"],
				// 	parentToAppend: symbolElement,
				// 	style: {
				// 		position: "absolute",
				// 		left: spinnableReel.NormalizedOriginalCanvasRect.x + "px",
				// 		top: spinnableReel.NormalizedOriginalCanvasRect.y + "px",
				// 		width: spinnableReel.NormalizedOriginalCanvasRect.width + "px",
				// 		height: spinnableReel.NormalizedOriginalCanvasRect.height + "px",
						

				// 		//backgroundColor: "rgba(0, 0, 0, 0.5)",
				// 		border: "1px solid red", boxSizing: "border-box",
				// 	}
				// })

				
				let parent: HTMLElement;

				if (s < this.numAdditionalRowsBottom)
				{
					parent = spinnableReel.BottomHiddenSymbols;
				}
				else if (s > spinnableReel.ReelDisplayGeometry.symbolsTotal - this.numAdditionalRowsTop -1)
				{
					parent = spinnableReel.TopHiddenSymbols;
				}
				else
				{
					parent = spinnableReel.MiddleVisibleSymbols;
				}

				let symbolElement = new MyCanvas(inflatedSymbolRect.Size(), {
					classes: ["symbol-" + s],
					parentToAppend: parent,
					style: {
						position: "absolute",
						left: inflatedSymbolRect.x + "px",
						top: inflatedSymbolRect.y + "px",
						width: inflatedSymbolRect.width + "px",
						height: inflatedSymbolRect.height + "px",

						boxSizing: "border-box",
						//backgroundColor: color
					},
				});


				spinnableReel.Canvases.push(symbolElement);
				this.canvas[index][s] = symbolElement;


				this.symbolElements.push(symbolElement);
				
				if (!this.symbolsInColumn[animationColumnIndex]) this.symbolsInColumn[animationColumnIndex] = [];
				this.symbolsInColumn[animationColumnIndex].push(symbolElement);
			}
		});
		


		this.maxSymbolHeightInPixels = this.reels.map(r => r.NormalizedOriginalCanvasRect.height).reduce((max, val) => max = Math.max(max, val), 0);
		this.maxReelHeightInSymbols = this.reels.map(r => r.Config.Height).reduce((max, val) => max = Math.max(max, val), 0);
		//console.log("Columns: ", this.symbolsInColumn);
	}

	public GetReelsInAnimationColumn(animationColumnIndex: number): S2_ISpinnableReel[]
	{
		return this.reelsInAnimationColumn[animationColumnIndex];
	}

	public GetSymbolsInColumn(columnIndex: number): MyCanvas[]
	{
		return this.symbolsInColumn[columnIndex];
	}
	

	public GetView(): HTMLElement {
		return this.slotWindowElement;
	}

	/** window size in pixels */
	public GetWindowSize(): Size {
		return this.params.windowRect.Size();
	}

	/** window rect in pixels */
	public GetWindowRect(): Rect {
		return this.params.windowRect;
	}

	/** window size in number of symbols */
	public GetWindowSymbolSize(): PlayWindow {
		return this.config.playWindow;
	}

	/** extended window size in number of symbols - additional symbols are on top for the porpuse of spin animation */
	public GetExtendendWindowSymbolSize() {
		return this.extendedWindowSymbolSize;
	}

	/** returns size of one symbol in pixels */
	public GetOriginalSymbolSize() {
		return this.symbolSize;
	}

	// public GetCenterOfReel(): Point []
	// {

	// 	this.reelWindowElemsList.forEach((reel:HTMLElement) =>
	// 	{
	// 		let r:ClientRect = reel.getBoundingClientRect();

	// 		let width: number = r.width;
	// 		let height: number = r.height;
	// 		this.centerOfReel.push(new Point(width/2 + r.left, height/2 + r.height));
			
	// 	});

	// 	return this.centerOfReel;
	// }

	public GetSymbolRect(column: number, row: number): Rect
	{
		// TODO
		return new Rect(
			this.params.windowRect.x + (column * this.symbolSize.Width),
			this.params.windowRect.y + (row * this.symbolSize.Height),
			this.symbolSize.Width,
			this.symbolSize.Height
		);
	}


	public GetAbsoluteSymbolRectReelRow(reel: number, rowOnReel: number): Rect
	{
		let r = this.reels[reel];
		return r.AbsoluteSymbolRects.get((r.Config.ExtraSymbolsAbove || 0)+ rowOnReel);
	}

	public GetReels(): S2_ISpinnableReel[]
	{
		return this.reels;
	}

	public GetReel(reelIndex: number): S2_ISpinnableReel
	{
		return this.reels[reelIndex];
	}

	public GetReelConfig(): S2_IReelConfig[]
	{
		return this.config.reelConfig;
	}

	public GetAnimationColumns(): number[]
	{
		return this.animationColumns;
	}

	public GetMaxSymbolHeight(): number
	{
		return this.maxSymbolHeightInPixels;
	}

	public GetMaxReelHeightInSymbols(): number
	{
		return this.maxReelHeightInSymbols;
	}

	public GetReelAt(col: number, row: number): S2_ISpinnableReel
	{
		// TODO create cache for each position
		let reels = this.reels.filter(r => 
			col >= r.Config.Col && col < r.Config.Col + r.Config.ColSpan &&
			row >= r.Config.Row && row < r.Config.Row + r.Config.RowSpan);

		return reels[0] || null;
	}

	// No extended symbols!
	public GetSymbolAt(col: number, row: number): S2_SymbolTranslation
	{
		let reel = this.GetReelAt(col, row);
		let reverserow = this.config.playWindow.Height - 1 - row;
		
		let translatedRow = Math.floor((reverserow - reel.Config.Row) * reel.Config.Height / reel.Config.RowSpan);// + reel.Config.ExtraSymbolsAbove;

		return {
			reelIndex: reel.Config.Index,
			rowIndex: translatedRow,
			reel: reel
		};
	}

	// size of one symbol, in pixels
	public GetSymbolSize() {
		return this.symbolSize;
	}

	public CanvasesReelRow(): MyCanvas[][]
	{
		return this.canvas;
	}

}
// }